import { createApp, provide } from 'vue'
import App from './App.vue'
import router from './router'

import './assets/base.scss'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import { setupStore } from '@/store'
import { setupRouter } from '@/router'

import { useAppStore } from '@/store/modules/app'

import { storeToRefs } from 'pinia'
import i18n from '@/i18n'

import * as emIcons from './icons'
import 'animate.css'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

const app = createApp(App)
app.use(ElementPlus)

app.use(VXETable)
for (let icon in emIcons) {
  app.component(`EmIcon${icon}`, emIcons[icon])
}

setupStore(app)

const appStore = useAppStore()
const { loadConfig } = appStore

app.directive('suggest-off', {
  mounted(el) {
    let dom = el.querySelectorAll('.el-input__inner')
    if (dom) {
      for (var g of dom) {
        g.setAttribute('autocomplete', 'new-password')
      }
    }
  },
})

loadConfig().then(() => {
  setupRouter(app)
    .isReady()
    .then(() => {
      //
      //
      const { event } = storeToRefs(useAppStore())
      const {locale}=i18n.global;
      locale.value = event.value.Version
      app.use(i18n)
      //const i18n = setupI18n(app)
      VXETable.setup({
        // 对组件内置的提示语进行国际化翻译
        i18n: (key, args) => i18n.global.t(key, args),
      })
      //更换
      document.title = event.value.EventName
      app.mount('#app')
    })
})
